import { View, Pressable } from "react-native"
import { type ReactNode } from "react"
import { Href, useRouter } from "expo-router"
import Icon from "@react-native-vector-icons/material-design-icons"
import { Text } from "./core"
import { useSafeAreaInsets } from "react-native-safe-area-context"

interface HeaderProps {
  title: string
  right?: ReactNode
  canGoBack?: boolean
  fallback?: Href
  withoutInsets?: boolean
  className?: string
}

export function Header({ title, right, canGoBack = true, fallback = "/dashboard" as const, withoutInsets, className }: HeaderProps) {
  const router = useRouter()
  const insets = useSafeAreaInsets()
  const _canGoBack = canGoBack ?? router.canGoBack()

  function handleBackPress() {
    if (router.canGoBack()) {
      router.back()
    } else {
      router.navigate(fallback)
    }
  }

  return (
    <View className={`bg-white  ${className}`}>
      <View
        className="flex-row justify-between items-center max-w-content-wide mx-auto w-full px-2 md:px-4 lg:px-6"
        style={{ paddingTop: withoutInsets ? 8 : insets.top, paddingEnd: 0 }}
      >
        <View className="flex-row items-center flex-1 h-11">
          {_canGoBack ? (
            <Pressable onPress={handleBackPress} className="justify-center items-center rounded p-1 active:opacity-70 web:px-2" style={{ paddingStart: 6 }}>
              <Icon name="arrow-right" size={24} color="black" />
            </Pressable>
          ) : null}
          <Text className={`text-lg md:text-xl lg:text-2xl font-bold text-gray-800 ${_canGoBack ? "ms-1 md:ms-2" : "ms-2 md:ms-4"}`}>{title}</Text>
        </View>
        <View className="h-11">{right ?? null}</View>
      </View>
    </View>
  )
}
